import styled from "styled-components";

import { searchFormFieldStyle } from "./BaseSearchFormFieldsStyle";

const ActionSearchFormField = styled.div`
    // Vanilla styles injection
    ${searchFormFieldStyle};
`;

export const InlineFormFieldStyle = styled(ActionSearchFormField).attrs(() => ({
    className: "aevi-search-form-field-container",
}))``;
